/* eslint-disable */
import axios from 'axios'
import config from '@/config'
import {isFailed, axiosWrapper} from '@/shared/api.utils'
import router from '@/router'

const globalSettingsModule = {
  namespaced: true,
  state: {
    all: null
  },
  mutations: {
    updateSettings(state, payload) {
      state.all = payload
    },
    applyGlobalSettingValue(state, payload) {
      // Find the setting that is loaded now, by id, rather than mutating the object the request
      // captured when it started -- reopening the page refetches into new objects, so the captured
      // one can be an orphan. Same reasoning as applySingleSettingValue in the settings module.
      let setting = (state.all || []).find(candidate => candidate.id === payload.setting.id)
      if (!setting) {
        return
      }
      setting.default = payload.newValue
    }
  },
  actions: {
    // `UpdateGlobalSettingsView.put` can refuse a value: briteapps-admin#1472 gives it a 400 from
    // validate_setting_value and a 404 for an unknown id, and it already answered 403 for a
    // non-superuser. So wait for the answer before touching local state. This used to be a mutation
    // that fired the PUT and assigned the new value on the next line, which is the same bug on the
    // global screen that this PR removes from the per-company one.
    async updateGlobalSetting(context, payload) {
      if (payload.newValue === payload.oldValue) {
        // do not send extra request
        return
      }

      let dataToSend = {
        token: localStorage.carrierToken,
        id: payload.setting.id,
        value: payload.newValue
      }

      await axiosWrapper(
        axios.put(`${config.url}/global-settings/${dataToSend.id}/`, dataToSend))

      context.commit('applyGlobalSettingValue', payload)
    },
    load: function (context, payload) {
      console.log('Loading global settings...')
      return new Promise((resolve, reject) => {
        let data
        let url
        url = config.url
        data = {
          token: localStorage.carrierToken
        }
        console.log('data', data)
        let promise = axios.get(`${config.url}/global-settings/`)

        promise.then((response) => {
          // success
          context.commit('updateSettings', response.data)

          resolve(response)
        })
        promise.catch((e) => {
          reject(e)
        })
      })
    },
  },
  getters: {},
}

export default globalSettingsModule
